'use strict';
import angular from 'angular'

function printerService($filter, dataHolderFactory, objectMakerFactory, onControllerLabelsForLanguageFactory,
                        localStorageService, parameterFactory, parameterNames, $translate, dataRequestService) {
  let doc = null, pdfConfig = {}, pageWidth = '', title, willSendByEmail, total;

  function addSpaceBetweenLines(size) {
    pdfConfig.rowPosition.y += size;
  }

  function setValuedElement(item) {
    doc.setTextColor(100);
    doc.text(pdfConfig.leftMargin, pdfConfig.rowPosition.y, item.label);
    doc.setTextColor(0);
    (item.type === 'plain') && (item.value = [item.value]);
    angular.forEach(item.value, function(elem) {
      const splitText = doc.splitTextToSize(elem.toString(), doc.internal.pageSize.width - pdfConfig.lineValueOffset - pdfConfig.leftMargin);
      doc.text(pdfConfig.lineValueOffset, pdfConfig.rowPosition.y, splitText);
      addSpaceBetweenLines(pdfConfig.defaultSpaceBetweenLines * splitText.length * 0.75);
    });
    addSpaceBetweenLines(-pdfConfig.defaultSpaceBetweenLines);
  }

  function setDetailedInfo(title, data) {
    addSpaceBetweenLines(pdfConfig.defaultSpaceBetweenLines);
    setComponentTitle(title.toUpperCase(), pdfConfig.textFontSize);
    addSpaceBetweenLines(20);
    angular.forEach(data, function(elem) {
      if (elem.render) {
        !(elem.value) && (elem.value = "");
        setValuedElement(elem);
        addSpaceBetweenLines(pdfConfig.defaultSpaceBetweenLines);
      }

    });
  }

  function setConstructionDetailsList(constructionSite, startY) {
    addSpaceBetweenLines(pdfConfig.defaultSpaceBetweenLines);

    const detailsColumns = ['Título', 'Detalhes'];
    const detailsRows = constructionSite.details.map(function(detail) {
      return [
        detail.deTitulo,
        detail.deDetalhe
      ];
    });

    doc.autoTable(detailsColumns, detailsRows, {
      theme: 'grid',
      styles: { overflow: 'linebreak' },
      margin: {
        top: 10,
        left: 10,
        right: 10,
        bottom: 10
      },
      headerStyles: { fillColor: [41, 128, 186] },
      columnStyles: {
        0: { columnWidth: 100 },
        1: { columnWidth: 475 },
      },
      startY: startY + 10
    });
  }

  function setConstructionSiteList(constructionSites) {
    addSpaceBetweenLines(pdfConfig.defaultSpaceBetweenLines);
    const constructionSitesColumns = ['Obra', 'Localização', 'Extensão'];

    let startY = pdfConfig.rowPosition.y;

    constructionSites.forEach(function(constructionSite) {
      const constructionSiteRows = [
        [
          constructionSite.name,
          constructionSite.addresses.join('\n'),
          constructionSite.extension ? constructionSite.extension + constructionSite.unit : '-'
        ]
      ];

      doc.autoTable(constructionSitesColumns, constructionSiteRows, {
        theme: 'grid',
        styles: { overflow: 'linebreak' },
        margin: {
          top: 10,
          left: 10,
          right: 10,
          bottom: 10
        },
        headerStyles: { fillColor: [41, 128, 186] },
        columnStyles: {
          0: { columnWidth: 'auto' },
          1: { columnWidth: 'wrap' },
          2: { columnWidth: 'wrap' },
        },
        startY: startY
      });

      if (constructionSite.details && constructionSite.details.length > 0) {
        setConstructionDetailsList(constructionSite, doc.autoTable.previous.finalY);
      }
        startY = doc.autoTable.previous.finalY + 20;
    });
  }

  function format(fontSize, fontType) {
    doc.setFontSize(fontSize);
    doc.setFontType(fontType);
  }

  function setComponentTitle(title, size) {
    format(size, 'bold');
    const splitText = doc.splitTextToSize(title, doc.internal.pageSize.width - pdfConfig.leftMargin - pdfConfig.rightMargin);
    doc.text(pdfConfig.leftMargin, pdfConfig.rowPosition.y, splitText);
    addSpaceBetweenLines(pdfConfig.defaultSpaceBetweenLines * splitText.length * 0.75);
  }

  function buildHeader() {
    if (!willSendByEmail) {
      const logoImage = localStorageService.get('logo');
      if (logoImage) {
        doc.addImage(logoImage, '', 15, 10, 70, 30);
      }
    }
    doc.setFontSize(16);
    doc.setTextColor(40);
    doc.setFontStyle('bold');
    let fontSize = doc.internal.getFontSize();
    let pageWidth = doc.internal.pageSize.width;
    const date = new Date();

    let txtWidth = doc.getStringUnitWidth(title) * fontSize / doc.internal.scaleFactor;
    doc.text(title, (pageWidth - (txtWidth + 10)), 25);

    doc.setFontSize(10);
    doc.setTextColor(40);
    doc.setFontStyle('normal');
    const text = $filter('date')(date, 'dd/MM/yyyy') + ' - ' + $filter('date')(date, 'HH:mm');
    fontSize = doc.internal.getFontSize();
    pageWidth = doc.internal.pageSize.width;

    txtWidth = doc.getStringUnitWidth(text) * fontSize / doc.internal.scaleFactor;
    doc.text(text, (pageWidth - (txtWidth + 10)), 40);
    doc.setFontSize(10);
    doc.setFontStyle('bold');
    doc.text(parameterFactory.getParameter(parameterNames.PRM_NAME_CLIENT).value, (15), 50);
  }

  function sortList(list) {
    const sortingObject = objectMakerFactory.sortingObject()[dataHolderFactory.getSortingOptionIndex()];
    return list.sort(function(a, b) {
      if (eval('a.' + sortingObject.selectedSort) > eval('b.' + sortingObject.selectedSort)) {
        return 1;
      }
      if (eval('a.' + sortingObject.selectedSort) < eval('b.' + sortingObject.selectedSort)) {
        return -1;
      }
      return 0;
    });
  }

  function buildContractsTable(columns, rows) {
    doc.autoTable(columns, rows, {
      drawCell:          function(cell, data) {
        if ((data.row.index === rows.length - 1) && !data.row.index === 0) {
          if (data.column.dataKey < 5) {
            doc.setFillColor(255, 255, 255);
            doc.rect(data.settings.margin.left, cell.y + 1, data.table.width, cell.height, 'F');
          }
          doc.setFontStyle('bold');
        }
      },
      theme:             'grid',
      styles:            { overflow: 'linebreak' },
      //columnStyles: {text: {columnWidth: 'auto'}},
      columnStyles:      {
        0: { columnWidth: 250 },
        1: { columnWidth: 140 },
        2: { columnWidth: 80 },
        3: { columnWidth: 80 },
        4: { columnWidth: 80 },
        5: { columnWidth: 80 }
      },
      margin:            {
        top:    60,
        left:   10,
        right:  10,
        bottom: 10
      },
      headerStyles:      { fillColor: [41, 128, 186] },
      beforePageContent: buildHeader
    });
  }

  function setContractList(list) {
    const columns = ['Contrato', $translate.instant('label.titulo.filtro.setor'), 'Localização', 'Situação', 'Empresa', 'Período', 'Valor do Contrato'];
    const rows = [];
    total.contracts = list.length;
    angular.forEach(list, function(contract) {
      rows.push([
        contract.name + ' - ' + contract.description,
        contract.contractor,
        contract.address || ' ',
        contract.status,
        contract.company,
        $filter('date')(contract.period.initialDate, 'dd/MM/yyyy') + ' a ' + $filter('date')(contract.period.finalDate, 'dd/MM/yyyy'),
        $filter('currency')(contract.amount, 'R$ ')
      ]);
      total.amount = total.amount + contract.amount;
    });
    rows.push(['', '', '', '', 'Total:', total.contracts + ' contratos', $filter('currency')(total.amount, 'R$ ')]);
    buildContractsTable(columns, rows);
  }

  this.pdfPrintingForContractDetails = function(isEmail, contract, infoGerais, infoPrazos, infoFinanceiras) {
    doc = new jsPDF('p', 'pt', 'a4', true);
    willSendByEmail = isEmail;
    title = onControllerLabelsForLanguageFactory.getLabel('DETAILS_REPORT_TITLE');
    pdfConfig = objectMakerFactory.viewObjectForPDFConfiguration();
    pageWidth = doc.internal.pageSize.width;
    buildHeader();
    setDetailedInfo(onControllerLabelsForLanguageFactory.getLabel('GENERAL_INFORMATION'), infoGerais);
    setDetailedInfo(onControllerLabelsForLanguageFactory.getLabel('TERM_CONTRACT'), infoPrazos);
    setDetailedInfo(onControllerLabelsForLanguageFactory.getLabel('FINANCIAL_INFORMATION'), infoFinanceiras);
    setConstructionSiteList(contract.construction);
    if (isEmail) {
      return doc.output('datauristring');
    }
    doc.save(contract.name + '.pdf');
  };

  this.pdfPrintingForContractList = function(_willSendByEmail, list) {
    doc = new jsPDF('l', 'pt', 'a4', true);
    total = objectMakerFactory.viewObjectControlForPdfTotal();
    willSendByEmail = _willSendByEmail;
    title = onControllerLabelsForLanguageFactory.getLabel('CONTRACTS_REPORT_TITLE');
    pdfConfig = objectMakerFactory.viewObjectForPDFConfiguration();
    pageWidth = doc.internal.pageSize.width;
    setContractList(sortList(list));
    if (_willSendByEmail) {
      return doc.output('datauristring');
    }
    doc.save('Contratos.pdf');
  };

  this.pdfPrintingForAllContractDetails = async function(isEmail, contracts) {
    doc = new jsPDF('p', 'pt', 'a4', true);
    willSendByEmail = isEmail;
  
    for (var i = 0; i < contracts.length; i++) {
      title = onControllerLabelsForLanguageFactory.getLabel('DETAILS_REPORT_TITLE');
      pdfConfig = objectMakerFactory.viewObjectForPDFConfiguration();
      pageWidth = doc.internal.pageSize.width;
        
      if (i !== 0) {
        doc.addPage();
      }

      buildHeader();
  
      let contrato = await this.getDetailsContract(contracts[i].id);
   
      const { resumoFinanceiro, totalResumoFinanceiro } = formatResumoFinanceiro(contrato);
      contrato.resumoFinanceiro = resumoFinanceiro;
      contrato.totalResumoFinanceiro = totalResumoFinanceiro;
  
      let informacoesGerais = objectMakerFactory.viewObjectForInformacoesGerais(contrato, false);
      let informacoesPrazos = objectMakerFactory.viewObjectForInformacoesPrazos(contrato);
      let informacoesFinanceiras = objectMakerFactory.viewObjectForInformacoesFinanceiras(contrato, false, true);
  
      setDetailedInfo(onControllerLabelsForLanguageFactory.getLabel('GENERAL_INFORMATION'), informacoesGerais);
      setDetailedInfo(onControllerLabelsForLanguageFactory.getLabel('TERM_CONTRACT'), informacoesPrazos);
      setDetailedInfo(onControllerLabelsForLanguageFactory.getLabel('FINANCIAL_INFORMATION'), informacoesFinanceiras);
      setConstructionSiteList(contrato.construction);
    }
  
    if (isEmail) {
      return doc.output('datauristring');
    }
    doc.save('ListaContratosDetalhados.pdf');
  };

  this.getDetailsContract = function(contractId) {
    dataRequestService.getContractDetails(contractId).then(function(result) {
      dataHolderFactory.updateContractDetails(result);
    }, function(error) {
      console.log(error);
    });
  };

  function formatResumoFinanceiro(contrato) {

    if (contrato && contrato.financialSummary && contrato.financialSummary.length) {
      const totalResumoFinanceiro = contrato.financialSummary.find(resumo => resumo.nuAno === 0);

      const resumoFinanceiro = contrato.financialSummary.filter(resumo => resumo.nuAno !== 0);

      return { totalResumoFinanceiro, resumoFinanceiro };
    }

    return {
      resumoFinanceiro: [],
      totalResumoFinanceiro: null,
    }
  }

  this.getDetailsContract = function(contractId) {
    return dataRequestService.getContractDetails(contractId).then(function(result) {
      return result;
    }, function(error) {
      console.log(error);
    });
  };
}

printerService.$inject = ['$filter', 'dataHolderFactory', 'objectMakerFactory', 'onControllerLabelsForLanguageFactory',
  'localStorageService', 'parameterFactory', 'parameterNames', '$translate', 'dataRequestService']
export default printerService


// WEBPACK FOOTER //
// ./src/app/scripts/services/printerService.js